import { combineReducers } from 'redux';
import authReducer from './authSlice';
import labelsReducer from './labelSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  labels: labelsReducer,
});

export default rootReducer;